import React from "react";
import { useFormContext } from "react-hook-form";

import { FaqItemsCard } from "../../../components/faq-items-card";
import { type CreateGamificationFormData } from "../../../validations/gamification.validation";

export const StepFaq: React.FC = () => {
  const form = useFormContext<CreateGamificationFormData>();

  return (
    <FaqItemsCard
      control={form.control}
      register={form.register}
      errors={form.formState.errors}
    />
  );
};
